import {ReactElement, useState} from "react";
import VZThinkingHeader from "./components/VZThinkingHeader";
import VZThinkingStep from "./components/VZThinkingStep";
import useVZThinkingRunner, {VZThinkingStepConfig} from "./useVZThinkingRunner";
import css from "./styles/vz-thinking.module.scss";


export interface VZThinkingProps {
    steps: VZThinkingStepConfig[];
    completedTitle?: string;
    onComplete?: () => void;
    defaultExpanded?: boolean;
}

// displays a series of steps with a progress bar, used to track and communicate whats
// happening. The steps can either be given arbitrary timing for when to complete, or you
// can pass functions to run and let promise resolutions drive them.
export default function VZThinking(props: VZThinkingProps): ReactElement {
    const stepStates = useVZThinkingRunner(props.steps, props.onComplete);
    const [isExpanded, setIsExpanded] = useState(props.defaultExpanded ?? true);

    return (
        <div className={css.vzThinking}>
            <VZThinkingHeader
                steps={stepStates}
                completedTitle={props.completedTitle}
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            />

            <div className={`${css.stepWrapper} ${isExpanded ? css.isExpanded : ""}`}>
                {stepStates.map((step, index) =>
                    <VZThinkingStep
                        key={index}
                        step={step}
                        isLast={index === stepStates.length - 1}
                    />
                )}
            </div>
        </div>
    );
}
